import { useRef } from "react";
import { Modal } from "antd";
import { useQuery } from "react-query";
import { getTasksStats } from "../../service";

export type TasksStat = { name: string; count: number; color?: string };

const parseStat = (label: any): TasksStat => {
  // Backend returns labels as "Name: count" strings.
  const [name, count] = (label?.text ?? "").split(":");
  return { name: (name ?? "").trim(), count: Number(count) || 0, color: label?.color };
};

// Shared tasks-attention stats (tasks to do / overdue / unread comments).
// `notifyOnIncrease` enables the legacy "new notification" modal and should be
// enabled by exactly one mounted component (NotificationBell).
export const useTasksStats = (notifyOnIncrease = false) => {
  const previousStateRef = useRef<Record<string, number>>({});

  const query = useQuery<any, Error>(["/tasks-stats"], () => getTasksStats(), {
    refetchInterval: 1000 * 120,
    refetchIntervalInBackground: true,
    onSuccess(data) {
      if (!notifyOnIncrease) return;
      const currentState = ((data?.labels as any[]) ?? []).reduce(
        (acc: any, current: any) => {
          const split = current?.text.split(":");
          acc[split[0]] = Number(split[1]);
          return acc;
        },
        {}
      );
      Object.entries(currentState).forEach(([key, value]: any) => {
        if (previousStateRef.current[key] < value) {
          Modal.info({
            title: "Nowe powiadomienie",
            content: `Nowe ${key.toLowerCase()}`,
          });
        }
      });
      previousStateRef.current = currentState;
    },
  });

  const stats: TasksStat[] = (query.data?.labels ?? []).map(parseStat);
  const total = stats.reduce((acc, s) => acc + s.count, 0);

  return { ...query, stats, total };
};
